import PriceSummaryCard from '../../../components/price-summary-card/PriceSummaryCard';
import type { Action, Content } from '../../../global-types/Content';
import useTracking from '../../../hooks/useTracking';
import { renderContent } from '../../../utils/renderContent';

type AfterActionProductPurchaseModalProps = {
  content: Content;
  viewId: number | undefined;
  dispatchActionEvent: (action: Action) => void;
  modalOpen: boolean;
  disableButton: boolean;
  setDisableButton: (value: boolean) => void;
};

function AfterActionProductPurchaseModal({
  content,
  viewId,
  dispatchActionEvent,
  modalOpen,
  disableButton,
  setDisableButton,
}: AfterActionProductPurchaseModalProps) {
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;
  const trackVisibilityElement = useTracking(content, modalOpen ? viewId : undefined);

  if (!view) return null;

  const { texts, linkStyledActions, buttonStyledActions } = renderContent({
    view,
    trackVisibilityElement,
    actionsConfig: {
      dispatchActionEvent,
      skipFirstAction: true,
      disableButton,
      setDisableButton,
    },
  });

  return (
    <div className="if modal-v19-content gap-24 small-padding flex-column" id="modal-v19-content">
      <div className="if flex-column flex-center text-align-center">{texts.slice(0, 2)}</div>
      <div className="if background-blue-100 border-radius-12">
        <div className="if p-24 flex-center flex-column gap-2 pb-16">
          {texts.slice(2, 5)}
          {view.viewElements.priceDetails && (
            <div className="if pt-16 size-w-100p">
              <PriceSummaryCard details={view.viewElements.priceDetails} />
            </div>
          )}
          {texts.slice(5)}
          <div className="if gap-16 mt-16 mb-40 size-w-100p flex-center flex-column">{buttonStyledActions}</div>
          <div className="if gap-8 flex-center flex-column">{linkStyledActions}</div>
        </div>
      </div>
    </div>
  );
}

export default AfterActionProductPurchaseModal;
